import Breadcrumb from "../SharedComponents/components/Breadcrumb/Breadcrumb";
import SellerLayout from "./components/SellerLayout";
import RightArrowIconSVG from "../SharedComponents/assets/icons/svg/RightArrowIconSVG";
import CreateAddressForm from "./components/AddressesComponents/CreateAddressForm";

const CreateAddressPage = () => {
    const breadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: "Sve adrese", href: "/addresses" },
        { title: "Dodaj adresu" }
    ];

    return (
        <SellerLayout>
            <div style={styles.topBar}>
                <div style={styles.iconWrapper}>
                    <RightArrowIconSVG />
                </div>
                <Breadcrumb
                    title={"Dodaj adresu"}
                    breadcrumbs={breadcrumbs}
                />
            </div>
            <CreateAddressForm />
        </SellerLayout>
    );
};

export default CreateAddressPage;

const styles = {
    topBar: {
        display: "flex",
    },
    iconWrapper: {
        filter: "brightness(0) saturate(100%)",
        scale: "80%",
        rotate: "180deg",
        paddingTop: "35px",
    },
};
